import "core-js/modules/es.array.reverse.js";
import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
var _dec, _dec2, _dec3, _class, _class2, _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, runInAction, makeObservable } from "mobx";
import { observer } from "mobx-react";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import getPath from "../../Core/getPath";
import Box from "../../Styled/Box";
import { RawButton } from "../../Styled/Button";
import { TextSpan } from "../../Styled/Text";
import BadgeBar from "../BadgeBar";
import Icon, { StyledIcon } from "../../Styled/Icon";
import WorkbenchList from "./WorkbenchList";
import { Category, DataSourceAction } from "../../Core/AnalyticEvents/analyticEvents";
import MappableMixin from "../../ModelMixins/MappableMixin";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let Workbench = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, observer(_class = (_class2 = class Workbench extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
  }
  disableAll() {
    this.props.terria.workbench.disableAll();
  }
  enableAll() {
    this.props.terria.workbench.enableAll();
  }
  collapseAll() {
    runInAction(() => {
      this.props.terria.workbench.collapseAll();
    });
  }
  expandAll() {
    runInAction(() => {
      this.props.terria.workbench.expandAll();
    });
  }
  removeAll() {
    this.props.terria.workbench.items.forEach(item => {
      var _this$props$terria$an;
      (_this$props$terria$an = this.props.terria.analytics) === null || _this$props$terria$an === void 0 || _this$props$terria$an.logEvent(Category.dataSource, DataSourceAction.removeAllFromWorkbench, getPath(item));
      this.props.terria.removeSelectedFeaturesForModel(item);
    });
    this.props.terria.workbench.removeAll();
    this.props.terria.timelineStack.items.clear();
  }
  render() {
    const {
      t
    } = this.props;
    const shouldExpandAll = this.props.terria.workbench.shouldExpandAll;

    // show enable all button if all items are disabled
    const showEnableAll = this.props.terria.workbench.items.filter(it => MappableMixin.isMixedInto(it)).every(it => !it.show);
    return /*#__PURE__*/_jsxs(Box, {
      column: true,
      fullWidth: true,
      styledMinHeight: "0",
      flex: 1,
      children: [/*#__PURE__*/_jsxs(BadgeBar, {
        label: t("workbench.label"),
        badge: this.props.terria.workbench.items.length,
        children: [showEnableAll ? /*#__PURE__*/_jsxs(_StyledRawButton, {
          onClick: () => this.enableAll(),
          children: [/*#__PURE__*/_jsx(StyledIcon, {
            glyph: Icon.GLYPHS.enable,
            light: true,
            styledWidth: "12px",
            displayInline: true
          }), /*#__PURE__*/_jsx(TextSpan, {
            textLight: true,
            small: true,
            isLink: true,
            children: t("workbench.enableAll")
          })]
        }) : /*#__PURE__*/_jsxs(_StyledRawButton2, {
          onClick: () => this.disableAll(),
          children: [/*#__PURE__*/_jsx(StyledIcon, {
            glyph: Icon.GLYPHS.disable,
            light: true,
            styledWidth: "12px",
            displayInline: true
          }), /*#__PURE__*/_jsx(TextSpan, {
            textLight: true,
            small: true,
            isLink: true,
            children: t("workbench.disableAll")
          })]
        }), shouldExpandAll ? /*#__PURE__*/_jsxs(_StyledRawButton3, {
          onClick: this.expandAll,
          children: [/*#__PURE__*/_jsx(StyledIcon, {
            glyph: Icon.GLYPHS.expandAll,
            light: true,
            styledWidth: "12px",
            displayInline: true
          }), /*#__PURE__*/_jsx(TextSpan, {
            textLight: true,
            small: true,
            isLink: true,
            children: t("workbench.expandAll")
          })]
        }) : /*#__PURE__*/_jsxs(_StyledRawButton4, {
          onClick: this.collapseAll,
          children: [/*#__PURE__*/_jsx(StyledIcon, {
            glyph: Icon.GLYPHS.collapse,
            light: true,
            styledWidth: "12px",
            displayInline: true
          }), /*#__PURE__*/_jsx(TextSpan, {
            textLight: true,
            small: true,
            isLink: true,
            children: t("workbench.collapseAll")
          })]
        }), /*#__PURE__*/_jsxs(_StyledRawButton5, {
          onClick: this.removeAll,
          children: [/*#__PURE__*/_jsx(StyledIcon, {
            glyph: Icon.GLYPHS.cancel,
            light: true,
            styledWidth: "12px",
            displayInline: true
          }), /*#__PURE__*/_jsx(TextSpan, {
            textLight: true,
            small: true,
            isLink: true,
            children: t("workbench.removeAll")
          })]
        })]
      }), /*#__PURE__*/_jsx(WorkbenchList, {
        viewState: this.props.viewState,
        terria: this.props.terria
      })]
    });
  }
}, _applyDecoratedDescriptor(_class2.prototype, "collapseAll", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "collapseAll"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "expandAll", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "expandAll"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeAll", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "removeAll"), _class2.prototype), _class2)) || _class);
export default withTranslation()(Workbench);
var _StyledRawButton = _styled(RawButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                display: flex;\n                align-items: center;\n                padding-left: 5px;\n                min-width: 90px;\n                justify-content: space-evenly;\n              "])));
var _StyledRawButton2 = _styled2(RawButton)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                display: flex;\n                align-items: center;\n                padding-left: 5px;\n                min-width: 90px;\n                justify-content: space-evenly;\n              "])));
var _StyledRawButton3 = _styled3(RawButton)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                display: flex;\n                align-items: center;\n                padding-left: 5px;\n                min-width: 90px;\n                justify-content: space-evenly;\n              "])));
var _StyledRawButton4 = _styled4(RawButton)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n                display: flex;\n                align-items: center;\n                padding-left: 5px;\n                min-width: 90px;\n                justify-content: space-evenly;\n              "])));
var _StyledRawButton5 = _styled5(RawButton).withConfig({
  displayName: "Workbench___StyledRawButton5",
  componentId: "sc-urfwi3-0"
})(["display:flex;align-items:center;padding:0 5px;min-width:90px;justify-content:space-evenly;svg{vertical-align:middle;padding-right:4px;}"]);